module.exports = __webpack_public_path__ + "static/img/success_count.38f6b04c.png";